import { createDomMotionComponent } from 'framer-motion'

/** IE 11 supported version of the motion component */
export const motion = {
    div: createDomMotionComponent("div"),
    span: createDomMotionComponent("span") ,
    svg: createDomMotionComponent("svg") ,
}